
export enum IntegrationTypeEnum {
  OPENAI = "OPENAI",
  GEMINI = "GEMINI",
  PIPEDRIVE = "PIPEDRIVE",
  AGENDOR = "AGENDOR",
  GPT_MAKER = "GPT_MAKER",
}
